"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentAddressRequiredDefault = void 0;
var CURRENT_ADDRESS_REQUIRED_FIELDS = new Set([
    'addressLine1',
    'city',
    'country',
    'state',
    'zip',
]);
var getCurrentAddressRequiredDefault = function (field) {
    return CURRENT_ADDRESS_REQUIRED_FIELDS.has(field);
};
exports.getCurrentAddressRequiredDefault = getCurrentAddressRequiredDefault;
